import { initializeErrorReporting } from '@eb/error-reporting';
import { getLocaleOverride, getParentLocale, setupAsync } from '@eb/i18n';
import {
    initDimensionsFromState,
    trackInitialPageView,
} from '@eb/site-analytics';
import React from 'react';
import { render } from 'react-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { dehydrate, Hydrate } from 'react-query/hydration';
import { App } from './app';

// retrieve data from server to hydrate on the client
const props = window.__SERVER_DATA__ || ({} as any);
const root = document.getElementById('root');

// retrieve dehydrated react-query state to hydrate
const FIVE_MINUTES = 5 * 60 * 1000;
const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: false,
            refetchOnWindowFocus: false,
            refetchOnReconnect: false,
            refetchOnMount: false,
            staleTime: FIVE_MINUTES,
        },
    },
});
const dehydratedState = window.__REACT_QUERY_STATE__;

const parentLocale = getParentLocale(
    getLocaleOverride() || props.env.localeInfo.locale,
);

const main = async () => {
    initializeErrorReporting();
    try {
        if (parentLocale !== 'en_US') {
            await setupAsync({
                parentLocale,
                translations: /* webpackChunkName: "organizer-profile-i18n-translation" */ import(
                    `./i18n/translations/${parentLocale}.json`
                ),
            });
        }
    } finally {
        const safeDehydratedState = dehydratedState
            ? dehydratedState
            : dehydrate(queryClient);

        render(
            <QueryClientProvider client={queryClient}>
                <Hydrate state={safeDehydratedState}>
                    <App {...props} />
                </Hydrate>
            </QueryClientProvider>,
            root,
        );
    }
};
main();

initDimensionsFromState(props);
trackInitialPageView(props.gaSettings);
